import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isOpen", "renderExtraOptions", "onOpenChange"];
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import { LikeLink, RouterLink } from '../../../components/AcademyLinks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import MobileNestedMenu from '../../../components/Modals/FullScreenModal/MobileNestedMenu';
import PanelSection from '../../../components/Modals/FullScreenModal/PanelSection';
import styled, { css } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
import AddToPlaylist from '../../savedItems/components/AddToPlaylist';
import CardMenuWatchLaterOption from '../../savedItems/components/CardMenuWatchLaterOption';
import ChangePlaylistThumbnail from '../../savedItems/components/ChangePlaylistThumbnail';
import CreatePlaylistLink from '../../savedItems/components/CreatePlaylistLink';
import StartPlaylistButton from '../../savedItems/components/StartPlaylistButton';
import { EditPlaylistButton } from '../../savedItems/components/EditPlaylistButton';
import { UploadPlaylistThumbnailButton } from '../../savedItems/components/UploadPlaylistThumbnailButton';
import { useUserOwnsPlaylist } from '../../savedItems/savedItemsQueries';
import { MobileSocialShareMenuOption } from '../../share/components/SocialShareMenuOption';
import { DuplicatePlaylistButton } from '../../savedItems/components/DuplicatePlaylistButton';
import { ArchivePlaylistButton } from '../../myPlaylists/components/ArchivePlaylistButton';
import { SavePlaylistButton } from '../../myPlaylists/components/SavePlaylistButton';
import { AssignPlaylistButton } from '../../playlistAssignments/components/AssignPlaylistButton';
import { PlaylistAssignmentsSearchProvider } from '../../playlistAssignments/components/PlaylistAssignmentsSearch';
import { UnAssignPlaylist, UnassignPlaylistHeader, UnassignPlaylistLoadMore } from '../../playlistAssignments/components/UnAssignPlaylist';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuRowStyle = css(["display:flex;flex-grow:1;justify-content:space-between;font-weight:initial;padding:12px 20px !important;"]);
export const MenuRow = styled.div.withConfig({
  displayName: "MobileCardMenu__MenuRow",
  componentId: "g7k8bx-0"
})(["", ""], MenuRowStyle);
export const MenuButton = styled(UIButton).withConfig({
  displayName: "MobileCardMenu__MenuButton",
  componentId: "g7k8bx-1"
})(["", ""], MenuRowStyle);
export const MenuLink = styled(RouterLink).withConfig({
  displayName: "MobileCardMenu__MenuLink",
  componentId: "g7k8bx-2"
})(["", ""], MenuRowStyle);
export const MenuLikeLink = styled(LikeLink).withConfig({
  displayName: "MobileCardMenu__MenuLikeLink",
  componentId: "g7k8bx-3"
})(["", " font-weight:500;"], MenuRowStyle);
const ShareButtonLabel = ({
  shareButtonLabel = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "learningCenter.common.share"
  })
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [shareButtonLabel, /*#__PURE__*/_jsx(UIIcon, {
    name: "right"
  })]
});
const ShareButtonContents = ({
  item,
  onShare,
  shareButtonLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.common.share"
  })
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(PanelSection, {
    showBorders: false,
    title: shareButtonLabel
  }), /*#__PURE__*/_jsx(MobileSocialShareMenuOption, {
    item: item,
    onShare: onShare
  })]
});
const TrackLessonMenuOptions = ({
  item,
  itemToShare,
  onOpenChange,
  children
}) => {
  const {
    id,
    type,
    language
  } = item;
  const closeModal = () => onOpenChange(false);
  const onAddToPlaylistClick = () => {
    closeModal();
    UsageTracker.track('playlistInteraction', {
      action: 'add-to-playlist',
      location: 'card-menu',
      itemId: id,
      contentType: type,
      language
    });
  };
  const onAddToNewPlaylistClick = () => {
    closeModal();
    UsageTracker.track('playlistInteraction', {
      action: 'add-to-new-playlist',
      location: 'card-menu',
      itemId: id,
      itemType: type,
      language
    });
  };
  const shareButtonLabel = itemToShare ? undefined : item.type === 'TRACK' ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.shareThis.shareTrack"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.shareThis.shareLesson"
  });
  return /*#__PURE__*/_jsxs(MobileNestedMenu, {
    indented: false,
    open: true,
    setIsOpen: onOpenChange,
    useBackText: true,
    useSidePanel: true,
    children: [/*#__PURE__*/_jsx(CardMenuWatchLaterOption, {
      item: item,
      onClick: closeModal,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      })
    }), /*#__PURE__*/_jsxs(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(AddToPlaylist, {
        item: item,
        loadMode: "button",
        loadMoreButton: /*#__PURE__*/_jsx(MenuLikeLink, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.cardMenu.loadMorePlaylists"
          })
        }),
        onPlaylistClick: onAddToPlaylistClick,
        renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PanelSection, {
            showBorders: false,
            title: /*#__PURE__*/_jsxs(UIFlex, {
              children: [/*#__PURE__*/_jsx(UIBox, {
                grow: 1,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyNav.heading.myPlaylists"
                })
              }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
                item: item,
                render: (linkContent, to) => /*#__PURE__*/_jsx(RouterLink, {
                  onClick: onAddToNewPlaylistClick,
                  to: to,
                  truncate: true,
                  children: linkContent
                }),
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.cardMenu.addToNewPlaylist"
                })
              })]
            })
          }), content]
        }),
        renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
          children: content
        }, key)
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.cardMenu.addToPlaylist"
      }), /*#__PURE__*/_jsx(UIIcon, {
        name: "right"
      })]
    }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
      item: item,
      render: (linkContent, to) => /*#__PURE__*/_jsx(MenuLink, {
        onClick: onAddToNewPlaylistClick,
        to: to,
        truncate: true,
        use: "unstyled",
        children: linkContent
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.cardMenu.addToNewPlaylist"
      })
    }), /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(ShareButtonContents, {
        item: itemToShare || item,
        onShare: closeModal,
        shareButtonLabel: shareButtonLabel
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(ShareButtonLabel, {
        shareButtonLabel: shareButtonLabel
      })
    }), children]
  });
};
const menuItemStyle = {
  textDecoration: 'none',
  fontWeight: 'normal',
  width: '100%'
};
const PlaylistMenuOptions = ({
  item,
  itemToShare,
  onOpenChange,
  children
}) => {
  const {
    id: playlistId
  } = item;
  const userIsOwner = useUserOwnsPlaylist(playlistId);
  const closeModal = () => onOpenChange(false);
  const shareButtonLabel = itemToShare ? undefined : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.shareThis.sharePlaylist"
  });
  return /*#__PURE__*/_jsxs(MobileNestedMenu, {
    indented: false,
    open: true,
    setIsOpen: onOpenChange,
    useBackText: true,
    useSidePanel: true,
    children: [/*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(StartPlaylistButton, {
        appearsIn: "playlist",
        playlistId: playlistId,
        showLoader: true,
        style: menuItemStyle,
        use: "unstyled"
      })
    }), userIsOwner && /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(EditPlaylistButton, {
        playlistId: playlistId,
        style: menuItemStyle,
        use: "unstyled"
      })
    }), userIsOwner && /*#__PURE__*/_jsxs(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ChangePlaylistThumbnail, {
          onItemClick: closeModal,
          playlistId: playlistId,
          renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(PanelSection, {
              showBorders: false,
              title: /*#__PURE__*/_jsx(UIFlex, {
                children: /*#__PURE__*/_jsx(UIBox, {
                  grow: 1,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "learningCenter.cardMenu.playlistItems"
                  })
                })
              })
            }), content]
          }),
          renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
            children: content
          }, key)
        }), /*#__PURE__*/_jsx(View, {
          as: "div",
          margin: "400",
          children: /*#__PURE__*/_jsx(UploadPlaylistThumbnailButton, {
            onImageUpload: closeModal,
            playlistId: playlistId,
            use: "tertiary"
          })
        })]
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.cardMenu.changeThumbnail"
      }), /*#__PURE__*/_jsx(UIIcon, {
        name: "right"
      })]
    }), /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(ShareButtonContents, {
        item: itemToShare || item,
        onShare: closeModal,
        shareButtonLabel: shareButtonLabel
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(ShareButtonLabel, {
        shareButtonLabel: shareButtonLabel
      })
    }), /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(AssignPlaylistButton, {
        playlistId: playlistId,
        style: menuItemStyle,
        tooltipProps: {
          placement: 'right'
        },
        use: "unstyled"
      })
    }), /*#__PURE__*/_jsxs(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(PlaylistAssignmentsSearchProvider, {
        children: /*#__PURE__*/_jsx(UnAssignPlaylist, {
          loadMoreButton: /*#__PURE__*/_jsx(MenuLikeLink, {
            children: /*#__PURE__*/_jsx(UnassignPlaylistLoadMore, {})
          }),
          onUnassigned: closeModal,
          playlistId: playlistId,
          renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(PanelSection, {
              showBorders: false,
              title: /*#__PURE__*/_jsx(UnassignPlaylistHeader, {})
            }), content]
          }),
          renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
            children: content
          }, key)
        })
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.unassignPlaylist"
      }), /*#__PURE__*/_jsx(UIIcon, {
        name: "right"
      })]
    }), /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(DuplicatePlaylistButton, {
        playlistId: playlistId,
        style: menuItemStyle,
        use: "unstyled"
      })
    }), /*#__PURE__*/_jsx(SavePlaylistButton, {
      onClick: closeModal,
      playlistId: playlistId,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      }),
      style: {
        width: '100%'
      }
    }), /*#__PURE__*/_jsx(ArchivePlaylistButton, {
      onClick: closeModal,
      playlistId: playlistId,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      }),
      showTooltip: true,
      style: {
        width: '100%'
      }
    }), children]
  });
};
const ShortMenuOptions = ({
  item,
  itemToShare,
  onOpenChange,
  children
}) => {
  const {
    id: shortId
  } = item;
  const closeModal = () => onOpenChange(false);
  const onAddToPlaylistClick = () => {
    closeModal();
    UsageTracker.track('playlistInteraction', {
      action: 'add-to-playlist',
      location: 'card-menu',
      itemId: shortId
    });
  };
  const onAddToNewPlaylistClick = () => {
    closeModal();
    UsageTracker.track('playlistInteraction', {
      action: 'add-to-new-playlist',
      location: 'card-menu',
      itemId: shortId
    });
  };
  const shareButtonLabel = itemToShare ? undefined : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.shareThis.shareShort"
  });
  return /*#__PURE__*/_jsxs(MobileNestedMenu, {
    indented: false,
    open: true,
    setIsOpen: onOpenChange,
    useBackText: true,
    useSidePanel: true,
    children: [/*#__PURE__*/_jsx(CardMenuWatchLaterOption, {
      item: item,
      onClick: closeModal,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      })
    }), /*#__PURE__*/_jsxs(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(AddToPlaylist, {
        item: item,
        loadMode: "button",
        loadMoreButton: /*#__PURE__*/_jsx(MenuLikeLink, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.cardMenu.loadMorePlaylists"
          })
        }),
        onPlaylistClick: onAddToPlaylistClick,
        renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PanelSection, {
            showBorders: false,
            title: /*#__PURE__*/_jsxs(UIFlex, {
              children: [/*#__PURE__*/_jsx(UIBox, {
                grow: 1,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyNav.heading.myPlaylists"
                })
              }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
                item: item,
                render: (linkContent, to) => /*#__PURE__*/_jsx(RouterLink, {
                  onClick: onAddToNewPlaylistClick,
                  to: to,
                  truncate: true,
                  children: linkContent
                }),
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.cardMenu.addToNewPlaylist"
                })
              })]
            })
          }), content]
        }),
        renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
          children: content
        }, key)
      }),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.cardMenu.addToPlaylist"
      }), /*#__PURE__*/_jsx(UIIcon, {
        name: "right"
      })]
    }), /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(ShareButtonContents, {
        item: itemToShare || item,
        onShare: closeModal,
        shareButtonLabel: shareButtonLabel
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(ShareButtonLabel, {
        shareButtonLabel: shareButtonLabel
      })
    }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
      item: item,
      render: (linkContent, to) => /*#__PURE__*/_jsx(MenuLink, {
        onClick: onAddToNewPlaylistClick,
        to: to,
        truncate: true,
        use: "unstyled",
        children: linkContent
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.cardMenu.addToNewPlaylist"
      })
    }), children]
  });
};
const MobileCardMenu = _ref => {
  let {
      children,
      isOpen,
      renderExtraOptions,
      onOpenChange
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    type
  } = props.item;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, isOpen && /*#__PURE__*/_jsxs(_Fragment, {
      children: ["(", type === 'PLAYLIST' && /*#__PURE__*/_jsx(PlaylistMenuOptions, Object.assign({
        onOpenChange: onOpenChange
      }, props, {
        children: renderExtraOptions && renderExtraOptions(onOpenChange)
      })), (type === 'TRACK' || type === 'LESSON') && /*#__PURE__*/_jsx(TrackLessonMenuOptions, Object.assign({
        onOpenChange: onOpenChange
      }, props, {
        children: renderExtraOptions && renderExtraOptions(onOpenChange)
      })), type === 'SHORT_FORM_CONTENT' && /*#__PURE__*/_jsx(ShortMenuOptions, Object.assign({
        onOpenChange: onOpenChange
      }, props, {
        children: renderExtraOptions && renderExtraOptions(onOpenChange)
      })), ")"]
    })]
  });
};
export default MobileCardMenu;